<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <v-sheet class="w-full code-flex">
        <i-card-vertical class="pr-3 w-hfull" headerTitle="시스템 코드" :useBtnList="buttonUseListMain" @btnAdd="btnAddMain()" device="web">
          <template v-slot:body>
            <DxDataGrid
              id="commonManageDataMain"
              class="layout-col-height00"
              :ref="dxDataGridMainRef"
              :data-source="gridMain"
              :remote-operations="false"
              :hover-state-enabled="true"
              :allow-column-resizing="true"
              :allow-column-reordering="true"
              :row-alternation-enabled="true"
              :column-auto-width="true"
              :show-borders="true"
              :width="grid.width"
              :show-row-lines="true"
              key-expr="id"
              :focused-row-enabled="true"
              :column-hiding-enabled="grid.columnHidingEnabled"
              @focused-row-changed="onFocusedRowChanged"
              @editing-start="onEditingStart"
              @editor-preparing="onEditorPreparing"
            >
              <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

              <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

              <!-- <DxColumn
                      data-field="id"                                               
                      :visible="false"
              />-->
              <DxColumn data-field="compId" caption="사업장번호" alignment="center" :visible="false" />

              <DxColumn data-field="clntId" caption="고객번호" alignment="center" :visible="false" />

              <DxColumn
                data-field="majorDiv"
                data-type="string"
                caption="시스템 구분"
                width="85px"
                alignment="center"
                css-class="devest-grid-header-require"
              >
                <DxLookup :data-source="columnDiv" value-expr="minorCd" display-expr="minorNm" />
              </DxColumn>

              <DxColumn data-field="majorCd" caption="공통코드" width="80px" data-type="string" alignment="center"></DxColumn>

              <DxColumn
                data-field="majorNm"
                caption="공통코드명"
                width="220px"
                data-type="string"
                alignment="left"
                css-class="devest-grid-header-require"
              />

              <DxColumn data-field="majorType" caption="시스템 타입" data-type="string" width="85px" alignment="left">
                <DxLookup :data-source="majorTypeList" value-expr="minorCd" display-expr="minorNm" />
              </DxColumn>

              <DxColumn data-field="remark" caption="비고" data-type="string" width="220px" alignment="left" />

              <template #checkBoxEditor="{ data: cellInfo }">
                <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="(value) => onCheckValueChanged(value, cellInfo)" />
              </template>
            </DxDataGrid>
          </template>
        </i-card-vertical>
        <i-card-vertical class="w-hfull" headerTitle="상세 코드" :useBtnList="buttonUseListMain" @btnAdd="btnAddDetail()" device="web">
          <template v-slot:body>
            <DxDataGrid
              class="layout-col-height00"
              :ref="dxDataGridDetailRef"
              :data-source="gridDetail"
              :remote-operations="false"
              :hover-state-enabled="true"
              :allow-column-resizing="true"
              :allow-column-reordering="true"
              :column-auto-width="true"
              :show-borders="true"
              :show-row-lines="true"
              :focused-row-enabled="true"
              key-expr="minorCd"
              key="minorCd"
              parent-id-expr="majorCd"
              :column-hiding-enabled="grid.columnHidingEnabled"
              @editor-preparing="detailOnEditorPreparing"
              @editing-start="onEditingStart"
            >
              <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

              <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

              <DxColumn data-field="clntId" caption="고객번호" alignment="center" :visible="false" />

              <DxColumn data-field="commDiv" caption="사업장번호" alignment="center" :visible="false" />

              <DxColumn
                data-field="minorCd"
                caption="상세코드"
                width="120px"
                counter
                data-type="string"
                alignment="center"
                css-class="devest-grid-header-require"
              ></DxColumn>

              <DxColumn
                data-field="minorNm"
                caption="상세코드명"
                width="150px"
                data-type="string"
                alignment="left"
                css-class="devest-grid-header-require"
              ></DxColumn>

              <DxColumn
                data-field="useYn"
                data-type="boolean"
                caption="사용"
                width="100px"
                alignment="center"
                edit-cell-template="checkBoxEditor"
              ></DxColumn>

              <DxColumn data-field="ordSeq" caption="순번" data-type="number" width="100px" alignment="center"></DxColumn>
              <DxColumn data-field="extra1" caption="extra1" data-type="string" alignment="left" />
              <DxColumn data-field="extra2" caption="extra2" data-type="string" alignment="left" />
              <DxColumn data-field="extra3" caption="extra3" data-type="string" alignment="left" />
              <DxColumn data-field="extra4" caption="extra4" data-type="string" alignment="left" />
              <DxColumn data-field="extra5" caption="extra5" data-type="string" alignment="left" />
              <DxColumn data-field="minorDesc" caption="내용" data-type="string" alignment="left" />
              <DxColumn data-field="fileNm" caption="파일명" data-type="string" alignment="left" :visible="false" />

              <DxColumn data-field="file" caption="파일" data-type="string" alignment="left" :visible="false" />

              <DxColumn data-field="fileId" caption="파일아이디" data-type="number" alignment="left" :visible="false" />

              <DxColumn data-field="__fileUpdate__" caption="파일수정여부" data-type="boolean" alignment="left" :visible="false" />

              <DxColumn
                data-field="extension"
                :width="300"
                cell-template="extensionIconTemplate"
                edit-cell-template="extensionIconTemplate"
                caption="파일"
                alignment="left"
              />
              <template #extensionIconTemplate="{ data: cellInfo }">
                <v-row v-if="!cellInfo.data.__created__" no-gutters>
                  <v-col class="pl-2 pt-1 d-flex" cols="10">
                    <span class="dx-datagrid-content-file-name-text">{{ cellInfo.data.fileNm }}</span>
                    <span class="pl-2 d-flex align-center">
                      <div v-if="cellInfo.value == '' || cellInfo.value == null" />

                      <svg-icon class="excel_icon mr-2" v-else-if="cellInfo.value == 'xlsx' || cellInfo.value == 'xls'" icon-class="excel" />

                      <svg-icon class="jpg_icon mr-2" v-else-if="cellInfo.value == 'jpg'" icon-class="jpg" />

                      <svg-icon class="pdf_icon mr-2" v-else-if="cellInfo.value == 'pdf'" icon-class="pdf" />

                      <svg-icon class="png_icon mr-2" v-else-if="cellInfo.value == 'png'" icon-class="png" />

                      <svg-icon class="txt_icon mr-2" v-else-if="cellInfo.value == 'txt'" icon-class="txt" />

                      <svg-icon class="ppt_icon mr-2" v-else-if="cellInfo.value == 'ppt' || cellInfo.value == 'pptx'" icon-class="ppt" />

                      <svg-icon class="zip_icon mr-2" v-else-if="cellInfo.value == 'zip' || cellInfo.value == 'cab'" icon-class="zip" />

                      <svg-icon class="doc_icon mr-2" v-else-if="cellInfo.value == 'doc' || cellInfo.value == 'docx'" icon-class="doc" />

                      <svg-icon class="hwp_icon mr-2" v-else-if="cellInfo.value == 'hwp' || cellInfo.value == 'hwpx'" icon-class="hwp" />

                      <svg-icon class="file_default_icon ml-2" v-else icon-class="file_default" />

                      <v-btn v-if="cellInfo.value" elevation="0" color="btn_sub" dark x-small @click="fileDownload(cellInfo.data)">
                        <!-- <svg-icon icon-class="download"></svg-icon> -->
                        다운로드
                      </v-btn>
                    </span>
                  </v-col>
                  <v-col align="right" cols="2">
                    <v-btn icon v-if="cellInfo.value" role="clear" @click="clearClick(cellInfo)">
                      <svg-icon icon-class="close"></svg-icon>
                    </v-btn>
                    <v-btn
                      v-if="cellInfo.data.fileNm == '' || cellInfo.data.fileNm == undefined"
                      elevation="0"
                      color="btn_sub"
                      dark
                      x-small
                      class="pa-1 mr-2"
                      role="upload"
                      @click="uploadClick(cellInfo)"
                    >
                      <!-- <svg-icon icon-class="upload"></svg-icon> -->
                      업로드
                      <!-- 업로드 -->
                    </v-btn>
                  </v-col>
                </v-row>
              </template>

              <DxColumn data-field="remark" caption="비고" data-type="string" width="200px" alignment="left" />

              <template #checkBoxEditor="{ data: cellInfo }">
                <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="(value) => onCheckValueChanged(value, cellInfo)" />
              </template>
            </DxDataGrid>
            <DxFileUploader :ref="dxFileUploaderRef" :multiple="false" upload-mode="useButton" :visible="false" @value-changed="onFileValueChanged" />
          </template>
        </i-card-vertical>
      </v-sheet>
      <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch()" @btnSave="btnSave()" @btnDelete="btnDelete()"></i-card-right>
    </v-sheet>
  </v-container>
</template>
<script>
import { downloadFile, multiUpload, deleteFilesWithTarget } from '@/api/baseManage/fileUpload'
import { getCommonCode } from '@/api/common/commonApi'
import { deleteCommonManage, getCommonMajor, getCommonMinor, saveCommonManage } from '@/api/system/commonCodeManage'
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import { AesDecrypt } from '@/utils/aes256'
import DxCheckBox from 'devextreme-vue/check-box'
import { DxColumn, DxDataGrid, DxEditing, DxLookup, DxSelection } from 'devextreme-vue/data-grid'
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import { DxStringLengthRule } from 'devextreme-vue/validator'
import notify from 'devextreme/ui/notify'
import { getGrpAuthCd } from '@/utils/token'

import { getExtension } from '@/utils/common.js'
//
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    'i-card-vertical': iCardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxCheckBox,
    DxEditing,
    DxLookup,
    DxStringLengthRule,
    DxFileUploader,
  },

  data() {
    return {
      showPageSizeSelector: false,
      pagingSize: 17,
      dxDataGridMainRef: 'commonManageDataMain',
      dxDataGridDetailRef: 'commonManageDataDetail',
      dxFileUploaderRef: 'commonFileUploaderRef',
      buttonUseList: [
        'btnSearch', //조회
        'btnSave', //저장
        'btnDelete', //삭제
      ],
      buttonUseListMain: ['btnAdd'],
      buttonUseListDetail: ['btnAdd'],
      allMode: 'allPages',
      gridMain: [],
      gridDetail: [],
      //text, select Data
      selectDiv: [],
      columnDiv: [],
      majorTypeList: [],
      selectedDiv: '',
      txtCommonCd: '',
      txtCommonNm: '',
      //detail에 row 추가 시 들고오는 main의 majorCd
      createdMajorCd: '',
      mainId: '',
      focusedRowKey: '',
      clntId: null,
      compId: null,
      isDropZoneActive: false,
      imageSource: '',
      fileData: null,
      files: [],
      currentCellInfo: null,
      codePattern: /^[a-zA-z0-9]{1,10}$/i,
    }
  },
  beforeMount() {
    Promise.all([getCommonCode('CM001'), getCommonCode('CM002')]).then((response) => {
      this.columnDiv = response[0].list.slice()

      this.selectDiv = response[0].list.slice()
      this.selectDiv.unshift({ minorCd: '', minorNm: '전체' })
      this.majorTypeList = response[1].list.slice()
    })
  },
  mounted() {
    this.btnSearch()
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnAddMain() {
      let newRow = {
        id: this.gridMain.length + 1,
        majorType: 'S',
        majorDiv: 'C',
        clntId: 'COMMON',
      }
      Object.defineProperty(newRow, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true,
      })

      this.GetDataGrid(this.dxDataGridMainRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridMainRef).selectRows(newRow.id, true)
    },

    btnAddDetail() {
      let newRow = {
        majorCd: this.createdMajorCd,
        id: this.gridDetail.length + 1,
        clntId: 'COMMON',
        compId: this.getCompId(),
        useYn: 'Y',
      }
      if (this.mainId !== '' && this.mainId !== null) {
        Object.defineProperty(newRow, '__created__', {
          value: true,
          writable: true,
          enumerable: true,
          configurable: true,
        })
        this.GetDataGrid(this.dxDataGridDetailRef).newRow(newRow)
        this.GetDataGrid(this.dxDataGridDetailRef).selectRows(newRow.id, true)
      } else {
        this.vToastify(this.$t('공통코드 행을 먼저 선택해주세요'), 'info')
        // this.$vToastify.warning({ body: this.$t('공통코드 행을 먼저 선택해주세요') })
      }
    },
    btnSearch() {
      const grpAuthCd = getGrpAuthCd()
      if (grpAuthCd === 'master') this.clntId = this.getClntId()

      this.gridMain = []
      this.gridInit()
      this.gridDetailInit()
      this.openLoading('searching')

      let searchParams = {
        majorDiv: this.selectedDiv,
        majorCd: this.txtCommonCd,
        majorNm: this.txtCommonNm,
        clntId: 'COMMON',
      }
      getCommonMajor(searchParams, true)
        .then((response) => {
          if (response.status < 0) {
            this.vToastify(response.msg, 'error')
            // this.$vToastify.error({ body: response.msg })
          } else {
            this.gridMain = []
            this.gridMain = response.list
            this.gridDetail = []
            this.GetDataGrid(this.dxDataGridMainRef).endUpdate()
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridMainRef))

            if (this.gridMain == undefined) {
              this.gridMain = []
            }
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },

    async btnSave() {
      let selectedMainRows = await this.GetDataGrid(this.dxDataGridMainRef).getSelectedRowsData()
      let selectedDetailRows = await this.GetDataGrid(this.dxDataGridDetailRef).getSelectedRowsData()

      if (selectedMainRows.length === 0 && selectedDetailRows.length === 0) {
        this.vToastify(this.$t('선택된 데이터가 없습니다.'), 'info')
        // this.$vToastify.warning({ body: '선택된 데이터가 없습니다.' })
        return
      }
      if (selectedMainRows.length === 0 && this.createdMajorCd == undefined) {
        this.vToastify(this.$t('공통코드를 생성해주세요.'), 'info')
        // this.$vToastify.warning({ body: '선택된 데이터가 없습니다.' })
        return
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        (current) => {
          this.openLoading()
          this.GetDataGrid(this.dxDataGridMainRef).saveEditData()
          this.GetDataGrid(this.dxDataGridDetailRef).saveEditData()
          var main = selectedMainRows.findIndex((element) => element.majorNm == null || element.majorDiv == null)
          if (main >= 0) {
            this.vToastify(this.$t('필수항목 입력하세요.[공통코드명, 시스템 구분]'), 'info')
            // this.$vToastify.warning({ body: this.$t('필수항목 입력하세요.[공통코드명, 시스템 구분]') })
            this.GetDataGrid(this.dxDataGridMainRef).endUpdate()
            this.endLoading()
            return
          }
          var detail = selectedDetailRows.findIndex(
            (element) => element.minorCd == null || element.minorNm == null || element.minorCd == '' || element.minorNm == ''
          )
          if (detail >= 0) {
            this.vToastify(this.$t('필수항목 입력하세요.[상세코드, 상세코드명]'), 'info')
            // this.$vToastify.warning({ body: this.$t('필수항목 입력하세요.[상세코드, 상세코드명]') })
            this.GetDataGrid(this.dxDataGridMainRef).endUpdate()
            this.endLoading()
            return
          }

          var valid = ''
          var patternIndex = selectedMainRows.findIndex((element) => {
            if (element.majorCd == null) {
              valid == ''
            } else if (element.majorCd.match(this.codePattern) == null) {
              valid = 'majorCd'
              return true
            }
          })

          if (patternIndex >= 0) {
            this.vToastify(valid == 'majorCd' ? this.$t('10자리 이하로 입력해주세요.') : this.$t(''), 'info')
            // this.$vToastify.warning({ body: valid == 'majorCd' ? this.$t('5자리 이하로 입력해주세요.') : this.$t('') })
            this.GetDataGrid(this.dxDataGridMainRef).endUpdate()
            this.GetDataGrid(this.dxDataGridMainRef).endUpdate()
            this.endLoading()
            return
          }

          let saveData = []

          for (let i = 0; i < selectedMainRows.length; i++) {
            selectedMainRows[i].clntId = 'COMMON'
            selectedMainRows[i].__main__ = true
            saveData.push(selectedMainRows[i])
          }

          let fileData = []

          for (let i = 0; i < selectedDetailRows.length; i++) {
            selectedDetailRows[i].clntId = 'COMMON'
            selectedDetailRows[i].__detail__ = true
            saveData.push(selectedDetailRows[i])
            if ((selectedDetailRows[i].file != null && selectedDetailRows[i].file != '') || selectedDetailRows[i].__fileUpdate__ == true) {
              fileData.push(selectedDetailRows[i])
            }
          }
          saveCommonManage(saveData, true)
            .then((response) => {
              if (fileData.length !== 0) {
                // 파일저장
                this.saveFile(fileData).then((res) => this.btnSearch())
              } else {
                this.btnSearch()
              }
              this.gridInit(this.GetDataGrid(this.dxDataGridMainRef))
              this.gridInit(this.GetDataGrid(this.dxDataGridDetailRef))
            })
            .catch((error) => {
              if (error.response && error.response.data) {
                if (error.response.data.code == -2001) {
                  this.vToastify(this.$t(error.response.data.msg), 'info')
                }
              }
            })
            .finally((res) => {
              this.GetDataGrid(this.dxDataGridMainRef).endUpdate()
              this.GetDataGrid(this.dxDataGridDetailRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },

    saveFile(selectedDetailRows) {
      return new Promise((resolve, reject) => {
        selectedDetailRows.forEach((element) => {
          if (element.file == '') {
            //파일의 삭제 처리만
            let fileVO = {
              clntId: this.getClntId(),
              fileId: null,
              targetId: element.minorCd,
              targetType: element.majorCd,
              useYn: 'Y',
              __fileUpdate__: element.__fileUpdate__,
            }
            deleteFilesWithTarget(fileVO)
              .then((res) => {
                notify(this.$t('Save.success'), 'success', 300)
              })
              .finally(() => {
                resolve(true)
              })
          } else {
            // string변환된 파일을 다시 File 객체로
            var arr = element.file.split(','),
              mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]),
              n = bstr.length,
              u8arr = new Uint8Array(n)

            while (n--) {
              u8arr[n] = bstr.charCodeAt(n)
            }

            var file = new File([u8arr], `${element.fileNm}.${element.extension}`, { type: mime })

            // form 데이터로 전송
            var formData = new FormData()

            formData.append('files[]', file)

            let fileVO = {
              clntId: this.getClntId(),
              fileId: null,
              targetId: element.minorCd,
              targetType: element.majorCd,
              useYn: 'Y',
              __fileUpdate__: element.__fileUpdate__,
            }

            formData.append('FileVO', new Blob([JSON.stringify(fileVO)], { type: 'application/json' }))
            multiUpload(formData, false)
              .then((res) => {
                notify(this.$t('Save.success'), 'success', 300)
              })
              .finally(() => {
                resolve(true)
              })
          }
        })
      })
    },

    btnDelete() {
      var selectedMainRows = this.GetDataGrid(this.dxDataGridMainRef).getSelectedRowsData()
      var selectedDetailRows = this.GetDataGrid(this.dxDataGridDetailRef).getSelectedRowsData()
      if (selectedMainRows.length === 0 && selectedDetailRows.length === 0) {
        this.vToastify(this.$t('삭제할 코드를 선택해주세요.'), 'info')
        // this.$vToastify.warning({ body: this.$t('삭제할 코드를 선택해주세요.') })
        return
      }
      //삭제확인 메세지
      this.vToastifyPrompt(
        this.$t('선택한 코드를 삭제하시겠습니까?'),
        'info',
        (current) => {
          this.Delete()
        },
        null,
        true
      )
    },
    async Delete() {
      var selectedMainRows = await this.GetDataGrid(this.dxDataGridMainRef).getSelectedRowsData()
      selectedMainRows.forEach((element) => (element.__main__ = true))
      var selectedDetailRows = await this.GetDataGrid(this.dxDataGridDetailRef).getSelectedRowsData()
      selectedDetailRows.forEach((element) => (element.__detail__ = true))
      var selectedRows = selectedDetailRows.concat(selectedMainRows)
      //삭제 Flag
      selectedRows.forEach((element) => (element.__deleted__ = true))

      if (this.gridDetail.length > 0 && selectedMainRows.length > 0) {
        this.vToastifyPrompt(
          this.$t('공통코드를 삭제하시면 상세코드가 전부 삭제됩니다. 진행하시겠습니까?'),
          'info',
          (current) => {
            // 삭제
            deleteCommonManage(selectedRows, true).then((response) => {
              this.btnSearch()
            })
          },
          null,
          true
        )
      } else {
        deleteCommonManage(selectedRows, true)
          .then((response) => {
            this.deleteCallBack(selectedRows)
          })
          .finally(() => {
            this.endLoading()
          })
      }
    },
    uploadClick(e) {
      // 클릭했을 때 해당 열의 데이터를 들고 옴
      this.currentCellInfo = e
      let fileInstance = this.$refs[this.dxFileUploaderRef].instance
      let fileElement = fileInstance.element()
      let uploadButton = fileElement.querySelector(`.dx-button-content`)
      uploadButton.click()
    },
    clearClick(e) {
      this.GetDataGrid(this.dxDataGridDetailRef).cellValue(e.row.rowIndex, 'extension', '')
      this.GetDataGrid(this.dxDataGridDetailRef).cellValue(e.row.rowIndex, 'fileNm', '')
      this.GetDataGrid(this.dxDataGridDetailRef).cellValue(e.row.rowIndex, 'file', '')
      this.GetDataGrid(this.dxDataGridDetailRef).cellValue(e.row.rowIndex, '__fileUpdate__', true)

      this.GetDataGrid(this.dxDataGridDetailRef).selectRows(e.key, true)
    },
    fileDownload(e) {
      this.openLoading()
      // api 에 responseType: "blob" 필수, 백단에 byteArray(Blob)형태로 보내고 있기 때문
      let params = {
        clntId: e.clntId,
        writeDt: e.writeDt,
        docNo: e.docNo,
      }

      downloadFile(params)
        .then((res) => {
          let link = document.createElement('a')
          // 객체를 만들어서 생성
          let objectUrl = window.URL.createObjectURL(res)
          link.href = objectUrl
          link.download = `${e.fileNm}.${e.extension}`
          link.click()
        })
        .finally(() => this.endLoading())
      // 업로드로 파일을 올린 경우
      /*
      if (e.file != null && e.file !== '') {
        let link = document.createElement('a')
        link.href = e.file
        link.download = `${e.fileNm}.${e.extension}`
        link.click()
      }
      // 올리지 않은 상태로 파일을 다운 받는 경우
      else if (e.fileId != null && e.fileId !== 0) {
        this.openLoading()
        downloadFile(e.fileId)
          .then(res => {
            let link = document.createElement('a')
            // 객체를 만들어서 생성
            let objectUrl = window.URL.createObjectURL(res)
            link.href = objectUrl
            link.download = `${e.fileNm}.${e.extension}`
            link.click()
          })
          .finally(() => this.endLoading())
      } else {
        console.log('error', e)
      }
      */
    },

    ///////////////////////////////////////
    /*         DataGrid   Event          */
    ///////////////////////////////////////
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = (args) => {
          if (e.index > -1) valueChanged(args.value, e)
        }
      }
      if (e.parentType === 'dataRow' && e.dataField === 'majorDiv' && !e.row.data.__created__) {
        e.editorOptions.readOnly = true
      }
      if (e.parentType === 'dataRow' && e.row.data.__created__) {
        if (typeof e.row.data.majorCd !== 'undefined') {
          // 추가 중인 공통코드의 majorCd
          this.createdMajorCd = e.row.data.majorCd
        }
      }
    },
    detailOnEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = (args) => {
          if (e.index > -1) valueChanged(args.value, e)
        }
      }
      if (e.parentType === 'dataRow' && e.dataField === 'minorCd' && !e.row.data.__created__) {
        e.editorOptions.readOnly = true
      }
    },

    async onFileValueChanged(e) {
      let file = e.value[0]
      // file 객체를 data에 넣으면 Error로 인하여 file을 string으로 변환 후 넣음
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        // 확장자랑 파일명 가져오기
        let subFileName = getExtension(file.name)

        let rowIndex = this.currentCellInfo.row.rowIndex

        this.GetDataGrid(this.dxDataGridDetailRef).cellValue(rowIndex, 'extension', subFileName[1])
        this.GetDataGrid(this.dxDataGridDetailRef).cellValue(rowIndex, 'fileNm', subFileName[0])
        this.GetDataGrid(this.dxDataGridDetailRef).cellValue(rowIndex, 'file', reader.result)
        this.GetDataGrid(this.dxDataGridDetailRef).cellValue(rowIndex, '__fileUpdate__', true)

        let a = this.GetDataGrid(this.dxDataGridDetailRef).option('editing.changes')

        // 수정된 값 표시를 위해 클래스 추가
        // 포커싱이 아웃되면 클래스가 사라짐 개선 필요
        // let cellElement = this.GetDataGrid(this.dxDataGridDetailRef).getCellElement(rowIndex, this.currentCellInfo.columnIndex)
        // let className = ['dx-item-modified', 'dx-cell-modified']
        // cellElement.classList.add(...className)

        this.GetDataGrid(this.dxDataGridDetailRef).selectRows(this.currentCellInfo.key, true)
      }
      reader.onerror = (error) => {
        console.log('error', error)
        this.vToastify('파일업로드에 실패하였습니다. 다시 시도해주시기 바랍니다.', 'error')
        // this.$vToastify.error({ body: '파일업로드에 실패하였습니다. 다시 시도해주시기 바랍니다.' })
      }
    },

    onFocusedRowChanged(e) {
      if (e.rowIndex < 0) return
      if (e.row.rowType === 'data') {
        let searchParams = { majorCd: e.row.data.majorCd, clntId: this.getClntId() }
        // 추후 공통코드 compId 삭제될 예정 그 동안 clntId 넣어줌
        getCommonMinor(searchParams, true)
          .then((response) => {
            this.gridDetail = []
            this.gridDetail = response.list
            this.createdMajorCd = e.row.data.majorCd
            this.mainId = e.row.data.id
            this.gridDetailInit()
            this.GetDataGrid(this.dxDataGridDetailRef).option('focusedRowIndex', 0)
          })
          .finally(() => {
            //this.endLoading()
          })
      }
    },

    onEditingStart(e) {
      if (e.column.dataField == 'majorCd' && !e.data.__created__) e.cancel = true
    },

    // // 체크박스 값 변경될 시 타는 이벤트
    // onCheckValueChanged(value, selectRows) {
    //   selectRows.setValue(selectRows.value === 'Y' ? 'N' : 'Y')
    //   selectRows.component.updateDimensions()
    // },

    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridMainRef).selectRows(cellInfo.row.key, true)
      this.GetDataGrid(this.dxDataGridDetailRef).selectRows(cellInfo.row.key, true)
    },

    gridMainInit() {
      this.GetDataGrid(this.dxDataGridMainRef).clearSelection()
    },

    gridDetailInit() {
      this.GetDataGrid(this.dxDataGridDetailRef).clearSelection()
      this.GetDataGrid(this.dxDataGridDetailRef).cancelEditData()
      this.GetDataGrid(this.dxDataGridDetailRef).option('focusedRowIndex', -1)
    },

    gridInit() {
      this.GetDataGrid(this.dxDataGridMainRef).clearSelection()
      this.GetDataGrid(this.dxDataGridDetailRef).clearSelection()
      this.GetDataGrid(this.dxDataGridMainRef).cancelEditData()
      this.GetDataGrid(this.dxDataGridMainRef).option('focusedRowIndex', -1)
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(selectedRows) {
      var index1 = null
      selectedRows.forEach((key) => {
        if (key.__main__) {
          index1 = this.gridMain.findIndex((obj) => obj == key)
          this.gridMain.splice(index1, 1)
        } else if (key.__detail__) {
          index1 = this.gridDetail.findIndex((obj) => obj == key)
          this.gridDetail.splice(index1, 1)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$appBarHeight: 64px;
$cardTitleHeight: 48px;
$paddingHeight: 8px;

.user-col-height {
  height: 100vh;
  max-height: calc(100vh - (#{$appBarHeight} + (#{$cardTitleHeight} * 2) + (#{$paddingHeight} * 7)));
}

.dx-datagrid-content-file-name-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.dx-command-select {
  width: 30px !important;
  min-width: 30px !important;
}
#dropzone-external {
  width: 65px;
  height: 18px;
  background-color: rgba(183, 183, 183, 0.1);
  border-width: 1px;
  border-style: dashed;
  padding: 0px;
}

#dropzone-external > * {
  pointer-events: none;
}

#dropzone-external.dropzone-active {
  border-style: solid;
}

.widget-container > span {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
}

#dropzone-image {
  max-width: 100%;
  max-height: 100%;
}

.flex-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
}

.widget-container {
  margin-right: 320px;
}

.contents h4 {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 18px;
}

.contents {
  margin-top: 50px;
  margin-left: 10px;
  display: none;
}

.fileList {
  padding: 10px;
  width: 400px;
  background-color: rgba(183, 183, 183, 0.1);
}

.fileNm {
  height: 20px;
  font-weight: bold;
}

.fileList > .fileSize {
  height: 20px;
  font-size: 12px;
}
</style>
